export default __webpack_public_path__ + "static/media/32_3_0.41e25c0b.png";